<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Blocos de Questões</h5>
      <b-button
        v-if="hasPermission('adicionar_parametrosavaliacoes_blocos')"
        variant="primary"
        class="d-flex align-items-center"
        @click="irParaCadastro"
      >
        <i class="bi bi-plus-circle-fill mr-2" title="Novo Cadastro"></i>
      </b-button>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <input
        v-model="filters.categoria"
        placeholder="Filtrar por categoria"
        class="form-control mr-2"
        @input="filtrar"
      />
      <input
        v-model="filters.bloco"
        placeholder="Filtrar por bloco"
        class="form-control mr-2"
        @input="filtrar"
      />
      <b-button
        variant="secondary"
        @click="limparFiltros"
        class="d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-funnel mr-2" title="Limpar Filtros"></i>
      </b-button>
    </div>

    <!-- Tabela customizada -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('id')">
              # {{ arrow('id') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('categoria_nome')">
              Categoria {{ arrow('categoria_nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('bloco')">
              Bloco {{ arrow('bloco') }}
            </button>
          </th>
          <!-- <th>
            <button class="btn btn-link p-0" @click="changeSort('criado_em')">
              Criado {{ arrow('criado_em') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('atualizado_em')">
              Atualizado {{ arrow('atualizado_em') }}
            </button>
          </th> -->
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in blocos" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.categoria_nome || '—' }}</td>
          <td>{{ item.bloco }}</td>
          <!-- <td>{{ formatDate(item.criado_em) }}</td>
          <td>{{ formatDate(item.atualizado_em) }}</td> -->
          <td class="text-end">
            <i
              v-if="hasPermission('detalhar_parametrosavaliacoes_blocos')"
              class="bi bi-eye-fill text-primary mx-2"
              title="Detalhar"
              @click="detalhar(item.id)"
            ></i>
            <i
              v-if="hasPermission('alterar_parametrosavaliacoes_blocos')"
              class="bi bi-pencil-fill text-warning mx-2"
              title="Editar"
              @click="editar(item.id)"
            ></i>
            <i
              v-if="hasPermission('excluir_parametrosavaliacoes_blocos')"
              class="bi bi-trash-fill text-danger mx-2"
              title="Excluir"
              @click="excluir(item.id)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros
      </div>
      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limit"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
          @change="changeLimit"
        />
      </div>
      <div class="d-flex align-items-center">
        <b-pagination
          v-model="page"
          :per-page="limit"
          :total-rows="totalItems"
          size="sm"
          limit="5"
          @input="load"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import { BButton, BPagination, BFormSelect } from 'bootstrap-vue-next'
import { useSortableTable } from '@/utils/useSortableTable'
import { usePermissions } from '@/composables/usePermissions'

const router = useRouter()
const { fetchPermissions, hasPermission } = usePermissions()

const {
  items: blocos,
  totalItems,
  page,
  limit,
  filters,
  load,
  sort: changeSort,
  arrow
} = useSortableTable(
  `/configuracoes/parametros-avaliacoes/blocos`,
  { key: 'bloco', order: 'asc' }
)

const pageOptions = ref([10, 15, 20, 25, 50])
const startRow   = computed(() => (page.value - 1) * limit.value + 1)
const endRow     = computed(() => Math.min(page.value * limit.value, totalItems.value))

// function formatDate(dt) {
//   return dt ? new Date(dt).toLocaleDateString('pt-BR') : ''
// }

function filtrar() {
  page.value = 1
  load()
}
function limparFiltros() {
  filters.value.categoria = ''
  filters.value.bloco     = ''
  page.value = 1
  load()
}
function changeLimit() {
  page.value = 1
  load()
}

function irParaCadastro() {
  router.push('/configuracoes/parametros-avaliacoes/blocos/novo')
}
function detalhar(id) {
  router.push(`/configuracoes/parametros-avaliacoes/blocos/${id}/detalhar`)
}
function editar(id) {
  router.push(`/configuracoes/parametros-avaliacoes/blocos/${id}`)
}
async function excluir(id) {
  if (confirm('Deseja excluir este bloco?')) {
    await axios.delete(`/configuracoes/parametros-avaliacoes/blocos/${id}`)
    load()
  }
}

watch(page, () => {
  load()
})

watch(limit, () => {
  page.value = 1
  load()
})

onMounted(async () => {
  await fetchPermissions()
  filters.categoria = ''
  filters.bloco     = ''
  load()
})
</script>

<style scoped>
:deep(.pagination.pagination-sm .page-link) {
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}
.table-hover tr:hover { background-color: var(--bs-light); }
</style>
